import React, {useState, useEffect, useRef} from 'react';
import { useRouter } from 'next/router';
import { useSelector, useDispatch } from 'react-redux';
import { findCar } from '../rcaSlice';
import { unwrapResult } from '@reduxjs/toolkit';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import Badge from 'react-bootstrap/Badge';
import RCANextSteps from './RCANextSteps';
import RCAIssueNotice from '../info/RCAIssueNotice';
import ErrorMessage from '../../elements/ErrorMessage';
import styles from '../../styles/elements/Form.module.scss';
import rcastyles from '../../styles/rca/RCASearch.module.scss';
import {registrationOptions, initValidStateValue} from './searchOptions';
import { RadioField} from '../../utils/validation/compare/SearchValidators';
import { AutoVINField } from '../../utils/validation/compare/RCAValidators';
import { FormChecker } from '../../utils/validation/FormValidator';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faChevronRight, faCar} from '@fortawesome/free-solid-svg-icons';


const RCACarStart = (props) => {

    const {vehiclesNumber, CSRFToken, editStep, activeVehicle, editActiveVehicle, addNewCar} = props;

    const isMounted = useRef(null);
    const router = useRouter();
    const dispatch = useDispatch();

    const initValidState = {
        tip_inmatriculare: initValidStateValue,
        serie_sasiu: initValidStateValue,
    };
    const [isValid, editIsValid] = useState(initValidState);
    const [tip_inmatriculare, editTip_inmatriculare] = useState(registrationOptions[0]);
    const [serie_sasiu, editSerie_sasiu] = useState('');
    const [isLoading, editIsLoading] = useState(false);
    const [isError, editIsError] = useState(false);

    useEffect( ()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        }
        }, []
    )

    const findVehicle = async () => {
        try {
            const resultAction = await dispatch(findCar({
                CSRFToken,
                vin: serie_sasiu,
            }));

            const data = unwrapResult(resultAction);
            if (data.status == 'error') {
                editIsLoading(false);
                editIsValid({...isValid, serie_sasiu: {
                    help: 'invalid-feedback',
                    field: 'is-invalid',
                    error: data.message,
                }, });
            } else if ( data.status == '400') {
                editIsError('Sesiune expirată. Pagina se va reîncarca automat.');
                setTimeout(router.reload(window.location.pathname), 1000 );
            } else if (data.status == 'not found' || data.status == 'ok') {
                addNewCar({
                    serie_sasiu,
                    active: true,
                    car: {
                        tip_inmatriculare,
                        serie_sasiu
                    },
                    step: 'auto',
                });
            } else {
                editIsLoading(false);
                editIsError('Te rugăm să încerci mai târziu.');
            }
        } catch(err) {
            editIsLoading(false);
            editIsError('Momentan nu putem verifica seria de șasiu. Te rugăm să încerci din nou în câteva momente.');
        }
    }

    const saveCar = () => {

        let vehicle = {
            serie_sasiu,
            car:{
                tip_inmatriculare,
                serie_sasiu
            },
        };
        editActiveVehicle(vehicle);
    }

    const validationRules = {
        serie_sasiu: AutoVINField,
        tip_inmatriculare: {rule: RadioField, param: {field: 'tip_inmatriculare'}},
    };

    const nextSteps = ['Proprietar', 'Adresa', 'Conducatori auto'];
    
    //blur validation
    const validateFieldOnBlur = (e) => { 
        let value = e.target.value;
        if (e.target.type == 'checkbox') {
            value = e.target.checked;
        }
        let id= e.target.id;
    
        let res;
        if (validationRules[id]) {
            
            if (typeof validationRules[id] == 'object') {
                res = validationRules[id].rule(value, validationRules[id].param);
            } else {
                res = validationRules[id](value);
            }

            editIsValid(
                {  ...isValid, 
                    [id] : {
                        help: res.status ? 'valid-feeback' : 'invalid-feedback',
                        field: res.status ? 'is-valid' : 'is-invalid',
                        error: res.msg
                    }
                }
            );
        }
    }

    const handleEditField = (e) => {
        switch(e.target.name) {
            case 'tip_inmatriculare':
                let opt = registrationOptions.find( item => item.value == e.target.value);
                if (opt) {
                    editTip_inmatriculare(opt);
                }
                break;
            case 'serie_sasiu':
                editSerie_sasiu(e.target.value.toUpperCase());
                break;
        }
    }

    const backToAutoList = () => {editStep('list')}
    const chooseAuto = vehiclesNumber > 0 &&
        <Button variant="link" className="green" onClick={backToAutoList}>
            <FontAwesomeIcon icon={faCar} className="me-2 " height="16" width="16" />
            Listă Auto
            <Badge className="ms-2" pill variant="primary" >{vehiclesNumber}</Badge>
        </Button>;


    const inmatriculareField =   
        <Col xs={12} className={`${styles.radio} `}>
            <Row className="pb-3 align-items-center">
                <Form.Label column xs={12}>
                Stare înmatriculare
                </Form.Label>
                
                    {registrationOptions.map( (opt, i) =>
                    <Col sm={6} key={i}>
                        <Form.Check    
                            custom
                            name="tip_inmatriculare"
                            id={`tip_inamtriculare${i}`}
                            type="radio"
                            value={opt.value}
                            onChange={handleEditField}
                            onClick={validateFieldOnBlur}
                            checked={tip_inmatriculare.value == opt.value ? true : false}
                            label={opt.label}
                            className={`${isValid.tip_inmatriculare.field}`}
                        />  
                    </Col>
                    )}
                
                <Form.Text className={`d-block ps-3 mt-0 helper ${isValid.tip_inmatriculare.help}`} as="div">
                {isValid.tip_inmatriculare.error}  
                </Form.Text>
            </Row>
        </Col>;

    const VINField = 
        <Col xs={12} md={6}>
            <Form.Group >
                <Form.Label htmlFor="serie_sasiu" >Serie șasiu</Form.Label>
                <Form.Control name="serie_sasiu" id="serie_sasiu"
                    value={serie_sasiu}
                    onChange={handleEditField}
                    onBlur={validateFieldOnBlur}
                    className={isValid.serie_sasiu.field}
                    placeholder="poziție talon: E"
                /> 
                <Form.Text className={`helper ${isValid.serie_sasiu.help}`} as="div">
                    {isValid.serie_sasiu.error}
                </Form.Text>
            </Form.Group>
        </Col>;

    const buttonField = 
        <Col xs={12} md={6} >
            <Button className="w-100"
                variant="primary" 
                type="submit"
                disabled={isLoading ? true : false}
            > 
            {isLoading ? 
                <div className="d-flex align-items-center">
                    <Spinner animation="border" className="me-2" /> Te rugăm să aștepți
                </div>
                :
                <>
                    Start
                    <FontAwesomeIcon icon={faChevronRight} height="16" width="16" className="ms-2"/>
                </>
            }
            </Button>
        </Col>;

    const sendForm = (e) => {
        e.preventDefault();
        e.preventDefault();
        editIsLoading(true);
        editIsError(false);
        let validForm = FormChecker('rcaFrm', validationRules);
        if (validForm.status) {
            saveCar();
            findVehicle();
        } else {
            editIsValid(validForm.data);
            editIsLoading(false);
        }
    }

    const registrationInfo  = 
        tip_inmatriculare.value == 'in vederea inmatricularii' &&
        <RCAIssueNotice />;
    
    return (
        <>
            <section className={`${rcastyles.boxWrapper} p-3 mb-3`}>
                <div className="d-flex justify-content-between mb-3">
                    <h2 className="heading2">Autovehicul</h2>
                    {chooseAuto}
                </div>
            
                <Form id="rcaFrm" className={`${styles.root} ${rcastyles.formField}`} onSubmit={sendForm}>
                    <Row>
                        {/* {registrationField} */}
                        {inmatriculareField}
                    </Row>
                    {registrationInfo}
                    <Row>
                        {VINField}
                    </Row>
                    <Row>
                        {buttonField}
                    </Row>
                    {isError &&
                    <Row>
                        <Col xs={12} className="mt-3">
                        <ErrorMessage title="Eroare" message={isError} />
                        </Col>
                    </Row> 
                    }
                </Form>
            </section>

            {/* <RCANextSteps steps={nextSteps} /> */}
        </>
    );
}

export default RCACarStart;